import { format, utcToZonedTime } from 'date-fns-tz';
import React from 'react';

import {
  ActionBtnStyled,
  CategoryTitleStyled,
  ListItemStyled,
  TypographyStyled,
  VersionStyled,
  getPopupContentStyle,
} from './ReleaseNotePopup.styled';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Popup from 'components/Popup/Popup';
import Typography from 'components/Typography/Typography';
import { useResponsive } from 'contexts/ResponsiveContext';
import { CategoryIdE } from 'declarations/enums/releaseNotes';
import { StorageE } from 'declarations/enums/storage';
import { LatestReleaseNoteI } from 'declarations/interfaces/releaseNotes';
import { NotesListStyled } from 'pages/ReleasesPage/components/ReleaseNotes/ReleaseNotes.styled';

type ReleaseNotePopupT = {
  displayNotes: boolean;
  latestReleaseNote: LatestReleaseNoteI;
};

const ReleaseNotePopup: React.FC<ReleaseNotePopupT> = ({ displayNotes, latestReleaseNote }) => {
  const { isMobile } = useResponsive();

  return (
    <>
      {displayNotes && (
        <Popup isOpen={true} contentStyle={getPopupContentStyle(isMobile)}>
          <FlexContainer justify="flex-start" align="center">
            <Typography variant="h2" color="darkBlue">
              {format(utcToZonedTime(latestReleaseNote.releaseDate, 'UTC'), 'MMM do, yyyy', {
                timeZone: 'UTC',
              })}
            </Typography>
            {latestReleaseNote.version && (
              <VersionStyled variant="body3" color="darkBlue">
                v{latestReleaseNote.version}
              </VersionStyled>
            )}
          </FlexContainer>
          <CategoryTitleStyled variant="h4" color="darkBlue">
            {latestReleaseNote.categoryId === CategoryIdE.WhatsNew ? "What's new" : 'Fixed issues'}
          </CategoryTitleStyled>
          <NotesListStyled>
            <ListItemStyled>
              <TypographyStyled variant="body1">{latestReleaseNote.note}</TypographyStyled>
              {latestReleaseNote.description && (
                <TypographyStyled variant="body4">{latestReleaseNote.description}</TypographyStyled>
              )}
            </ListItemStyled>
          </NotesListStyled>
          <ActionBtnStyled
            type="button"
            variant="outline"
            size="xl"
            onClick={() => {
              localStorage.setItem(StorageE.IsLatestReleaseNoteDismissed, 'true');
              window.location.reload();
            }}
          >
            Dismiss
          </ActionBtnStyled>
        </Popup>
      )}
    </>
  );
};

export default ReleaseNotePopup;
